import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FILTER_FIELD } from '_constants';
const moment = require('moment');

export const LineItem = ({ ...props }) => {
  LineItem.propTypes = {
    selectRefferal: PropTypes.func.isRequired,
    currentReferralFilter: PropTypes.string,
    item: PropTypes.shape({
      firstName: PropTypes.string,
      middleName: PropTypes.string,
      lastName: PropTypes.string,
      timestampModified: PropTypes.string,
      contactKey: PropTypes.string.isRequired,
      item: PropTypes.object,
      opportunities: PropTypes.array
    })
  };

  const getleadAddress = (referral) => {
    const referralAddress = _.get(referral, 'addresses[0]', null);
    if (referralAddress) {
      const city = _.get(referralAddress, 'city', '');
      const stateOrProvince = _.get(referralAddress, 'stateOrProvince', '');
      const postalCode = _.get(referralAddress, 'postalCode', '');
      const addCommaCity = (city && stateOrProvince) ? ',' : '';
      return `${city} ${addCommaCity} ${stateOrProvince} ${postalCode}`;
    }
    return referralAddress;
  };

  const getOpportunityAddress = (address) => {
    const address1 = _.get(address, 'address1', '');
    const city = _.get(address, 'city', '');
    const stateOrProvince = _.get(address, 'stateOrProvince', '');
    const postalCode = _.get(address, 'postalCode', '');
    const addCommaAddress1 = (address1 && (city || stateOrProvince)) ? ',' : '';
    const addCommaCity = (city && stateOrProvince) ? ',' : '';
    return `${address1}${addCommaAddress1} ${city}${addCommaCity} ${stateOrProvince} ${postalCode}`;
  };

  const { item, currentReferralFilter } = props;

  const showOpportunityAddress = (opportunity) => {
    if (currentReferralFilter !== FILTER_FIELD.ALL_REFERRAL) {
      const status = opportunity.opportunityType;
      if (status && status === currentReferralFilter) {
        return true;
      }
      return false;
    }
    return true;
  };

  return (
    <React.Fragment>
      <li className='list-item' onClick={() => props.selectRefferal(item)}>
        <div className='referral-display'>
          <div className='name'>
            <div className='referral-name-width'>
              <div className={'referral-name'}>{`${item.firstName} ${item.middleName ? item.middleName : ''} ${item.lastName}`}</div>
            </div>
            <div className='time-stamp-width'>
              <div className={'time-stamp'}>{item.opportunities && item.opportunities.length > 0 && moment(item.opportunities[0].timestampModified).fromNow()}</div>
            </div>
          </div>
          {
            item.opportunities &&
            item.opportunities.slice(0, 2).map((opportunity, index) => {
              const showPropertyAddress = showOpportunityAddress(opportunity);
              if (showPropertyAddress) {
                let fullAddress = [];
                (opportunity.areasOfInterest || []).map(address => {
                  if (!address.type.includes('MLS') && fullAddress.length <= 0) {
                    fullAddress.push(address.value);
                  }
                });
                const address = _.get(opportunity, 'contactProperty.property.address', null);
                if (fullAddress.length <= 0) {
                  fullAddress = (address != null) ? getOpportunityAddress(address) : (opportunity.type === 'Seller') ? getleadAddress(item) : fullAddress;
                }
                return (
                  <div key={index} className={'display-address'}>
                    <div>
                      <span key={index} className={`lead-type-badge lead-${opportunity.type === 'Buyer' ? 'buying' : 'selling'}`} />
                    </div>
                    <span>{fullAddress}</span>
                  </div>
                );
              }
            })
          }
        </div>
      </li>
    </React.Fragment>
  );
  // return (
  //   <div onClick={() => props.selectRefferal(props.item.contactKey)}
  //     className='d-flex p-3 justify-content-between'
  //     style={{ height: '80%' }}
  //   >
  //     <div className='d-flex align-items-center'>
  //       <div
  //         className='d-flex align-items-center justify-content-center mr-3'
  //         style={{
  //           backgroundColor: 'rgb(230,230,230)',
  //           minWidth: 40,
  //           height: 40,
  //           borderRadius: 20
  //         }}
  //       >
  //         {getInitials(props.item.firstName, props.item.lastName, props.item.middleName)}
  //       </div>
  //       <div className='d-flex flex-column justify-content-between'>
  //         <div className='pt-1 pb-1'>
  //           {`${props.item.firstName} ${props.item.middleName ? props.item.middleName : ''} ${
  //             props.item.lastName
  //             }`}
  //         </div>
  //         <small className='pb-1 text-muted'>
  //           Updated {moment(props.item.timestampModified).fromNow()}
  //         </small>
  //       </div>
  //     </div>
  //     <div className='d-flex align-items-center'>
  //       <i className='ion-ios-arrow-right text-muted pl-3' />
  //     </div>
  //     <hr className='m-0 p-0 ml-3 mr-3' />
  //   </div>
  // );
};
